export function shouldBeTruthy(obj, key, objName) {
  const value = obj[key]
  const valid = !!value
  const prepend = objName ? `${objName}.` : ''
  if (!valid) {
    console.error(`${prepend}${key} is not truthy but ${value}`)
  }
  return valid
}

export function shouldBeBoolean(obj, key, objName) {
  return validateType(obj, key, 'boolean', objName)
}

export function shouldBeNumber(obj, key, objName) {
  return validateType(obj, key, 'number', objName)
}

function validateType(obj, key, expectedType, objName) {
  const actualType = typeof obj[key]
  const valid = actualType === expectedType
  const prepend = objName ? `${objName}.` : ''
  if (!valid) {
    console.error(`${prepend}${key} type is not ${expectedType} but ${actualType}`)
  }
  return valid
}
